import RequestOptions from 'owa-service/lib/RequestOptions';
import { getHeaders } from 'owa-headers';

export default function getGroupRoutedRequestInit(groupSmtp: string): RequestOptions {
    return {
        headers: getHeaders(groupSmtp, 'GroupMailbox'),
    };
}
